module.exports = "<div #baFullCalendar class=\"ba-full-calendar {{baFullCalendarClass || ''}}\"></div>\n"


//////////////////
// WEBPACK FOOTER
// /opt/stranka/FrontOffice/src/app/theme/components/baFullCalendar/baFullCalendar.html
// module id = ../../../../../src/app/theme/components/baFullCalendar/baFullCalendar.html
// module chunks = main